var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeamMemberConIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.1102 5.43683C2.9422 5.43683 2.7742 5.37308 2.64595 5.24483L0.866203 3.46508C0.609703 3.20858 0.609703 2.79308 0.866203 2.53733C1.1227 2.28083 1.53745 2.28008 1.79395 2.53658L3.1102 3.85283L6.2062 0.756828C6.4627 0.500328 6.87745 0.500328 7.13395 0.756828C7.39045 1.01333 7.39045 1.42883 7.13395 1.68533L3.57445 5.24483C3.4462 5.37308 3.2782 5.43683 3.1102 5.43683Z",
    fill: "#36A6A4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamMemberConIcon);
export default __webpack_public_path__ + "static/media/teamMemberConIcon.81d95d9c86a18a934f62bcb032febdfd.svg";
export { ForwardRef as ReactComponent };